import React from 'react';

const zipScheduleToString = (zip) => {
    let str = [];

    if (zip?.schedule?.monday) str.push('Mon');
    if (zip?.schedule?.tuesday) str.push('Tue');
    if (zip?.schedule?.wednesday) str.push('Wed');
    if (zip?.schedule?.thursday) str.push('Thr');
    if (zip?.schedule?.friday) str.push('Fri');
    if (zip?.schedule?.saturday) str.push('Sat');
    if (zip?.schedule?.sunday) str.push('Sun');

    return str.join(', ');
}

const formatPhoneNumber = (str = '') => {
    let m = [...str.matchAll(/^.*(\d{3}).*(\d{3}).*(\d{4})$/g)]?.[0];
    return (m && m.length === 4) ?
        <a href={'tel:+1' + m[1] + m[2] + m[3]}>({m[1]}) {m[2]}-{m[3]}</a>
    : '';
}

const formatTime = (str = '') => {
    let m = [...(str?.matchAll(/^(\d{1,2}):(\d{1,2})$/g) ?? [])]?.[0];

    if (!m || m.length !== 3) return 'None';

    let hr = parseInt(m[1]);
    let min = parseInt(m[2]);
    let suf = 'AM';

    if (hr >= 12) {
        hr -= 12;
        suf = 'PM';
    }

    if (hr === 0)
        hr = 12;

    return hr + ':' + min.toString().padStart(2, '0') + ' ' + suf;
}

const camelCaseToTitleCase = (str = '') => {
    let x = str.replace(/([A-Z])/g, ' $1');
    return (x?.[0]?.toString().toUpperCase()) + x.slice(1);
}

const timestampToHuman = (timestamp) => {
    if (!timestamp) return '';
    // Timestamps are always in UTC. Make sure there is a Z at
    // the end to tell the toLocaleString function that.
    if (!timestamp.endsWith('Z')) timestamp += 'Z';
    return new Date(timestamp).toLocaleString();
}

const capText = (text, length) =>
    ((text?.length ?? 0) > length)
        ? text.substring(0, length - 3) + '...'
        : text;

const formatNumber = (num) =>
    num?.toLocaleString()

export {
    zipScheduleToString,
    formatPhoneNumber,
    formatTime,
    camelCaseToTitleCase,
    timestampToHuman,
    capText,
    formatNumber,
};